import { makeStyles } from 'tss-react/mui'

export default makeStyles()({
  placeholder: {
    height: 356,
  },
})
